import { render, staticRenderFns } from "./TravelInfo.vue?vue&type=template&id=5dd9493a&scoped=true&"
import script from "./TravelInfo.vue?vue&type=script&lang=js&"
export * from "./TravelInfo.vue?vue&type=script&lang=js&"
import style0 from "./TravelInfo.vue?vue&type=style&index=0&id=5dd9493a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd9493a",
  null
  
)

export default component.exports